import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Tag } from '@coursera/cds-core';

import _t from 'i18n!nls/compound-assessments';

type Props = {
  score?: number;
  maxScore: number;
  isExtraCreditQuestion?: boolean;
};

const QuestionPoints = ({ score, maxScore, isExtraCreditQuestion }: Props) => {
  const nonNumberScore = (
    <FormattedMessage
      message={
        isExtraCreditQuestion
          ? _t('{maxScore} {maxScore, plural, =1 {extra credit point} other {extra credit points}}')
          : _t('{maxScore} {maxScore, plural, =1 {point} other {points}}')
      }
      maxScore={maxScore}
    />
  ) as React.ReactNode & React.ReactText;

  const fractionalScore = (
    <FormattedMessage
      message={
        isExtraCreditQuestion
          ? _t('{fractionalScore} {maxScore, plural, =1 {extra credit point} other {extra credit points}}')
          : _t('{fractionalScore} {maxScore, plural, =1 {point} other {points}}')
      }
      fractionalScore={
        <span dir="ltr">
          {score} / {maxScore}
        </span>
      }
      maxScore={maxScore}
    />
  ) as React.ReactNode & React.ReactText;

  return (
    <div style={{ whiteSpace: 'nowrap' }}>
      {typeof score !== 'number' ? (
        <Tag variant="status" priority="secondary">
          {nonNumberScore}
        </Tag>
      ) : (
        <Tag variant="status" priority="secondary">
          {fractionalScore}
        </Tag>
      )}
    </div>
  );
};

export default QuestionPoints;
